import axios from 'axios';

export const LOCATIONS = 'locations';

export function getLocations(params) {
  return axios.get(LOCATIONS, { params });
}
